// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_Law","cls2":"CoScientistPricingPage-cls2_Wiq CoScientistPricingPage-cls1_Law"};